import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';
import { IContentItemDefinition } from './types';

// Hook to fetch a content item's schema/definition
// Used by Form Builder to configure data source inputs
export function useContentLibraryItemSchema(
  contentId: string | null,
  token?: string
) {
  const { data, mutate, error, isLoading } = useSWR<IContentItemDefinition>(
    contentId ? `content-library/${contentId}/schema` : null,
    SWRFetcher({ method: 'GET' }, token)
  );

  return {
    data,
    mutate,
    error,
    isLoading,
  };
}
